import { __awaiter } from "tslib";
import Vue from 'vue';
import moment from 'moment';
const todayDate = moment().format('YYYY-MM-DD');
export default Vue.extend({
    name: 'spotTradeHistory',
    data: () => ({
        tempSearchPhrase: '',
        searchPhrase: '',
        datePickerMenuContextIsOpened: false,
        datePickerSettings: {
            type: 'date'
        },
        filters: {
            tradeType: 'ALL',
            tradePair: {
                baseAsset: 'База',
                quoteAsset: 'Котировка'
            },
            date: {
                fromDate: null,
                toDate: null
            }
        },
        tempDate: [],
        itemsList: [],
        baseAssetList: [],
        quoteAssetList: [],
        loadError: false,
        isRetry: false
    }),
    computed: {
        reducedItems() {
            const vm = this;
            return vm.searchPhrase.length ? vm.itemsList.filter((item) => {
                return item.name.toLowerCase().includes(vm.searchPhrase.toLowerCase());
            }) : vm.itemsList;
        },
        computedDateView() {
            const vm = this;
            const d = vm.tempDate;
            const formatDate = (date) => {
                return moment(date).format('DD.MM.YYYY');
            };
            if (d.length === 1) {
                return formatDate(d[0]);
            }
            else if (d.length === 2) {
                if (d[0] === d[1]) {
                    return formatDate(d[0]);
                }
                else {
                    if (moment(d[0]).isAfter(moment(d[1])))
                        return `${formatDate(d[1])} - ${formatDate(d[0])}`;
                    return `${formatDate(d[0])} - ${formatDate(d[1])}`;
                }
            }
            else
                return 'Выбрать';
        }
    },
    watch: {
        datePickerMenuContextIsOpened(v) {
            if (!v) {
                this.filters.date.fromDate = this.tempDate[0] === undefined ? null : this.tempDate[0] + 'T00:00:00.000Z';
                this.filters.date.toDate = this.tempDate[1] === undefined ? null : this.tempDate[1] + 'T23:59:59.999Z';
            }
        },
        filters: {
            handler() {
                this.init();
            },
            deep: true
        },
        tempSearchPhrase(v) {
            const vm = this;
            if (!v.length)
                vm.searchPhrase = '';
        }
    },
    methods: {
        resetFilters() {
            const vm = this;
            vm.tempSearchPhrase = '';
            vm.filters = {
                tradeType: 'ALL',
                tradePair: {
                    baseAsset: 'База',
                    quoteAsset: 'Котировка'
                },
                date: {
                    fromDate: null,
                    toDate: null
                }
            };
            vm.tempDate = [];
        },
        updateTempDate(newDates) {
            if (newDates.length > 1 && newDates[0] === newDates[1]) {
                this.tempDate = [];
                return;
            }
            if (newDates.length > 1 && moment(newDates[1]).isBefore(newDates[0])) {
                this.tempDate = [newDates[1], newDates[0]];
                return;
            }
            this.tempDate = newDates;
        },
        presetDate(subtract) {
            const vm = this;
            vm.tempDate = [moment().subtract(subtract, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
            vm.datePickerMenuContextIsOpened = false;
        },
        init() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.loadError = false;
                vm.isRetry = true;
                const filters = new URLSearchParams();
                if (vm.filters.tradeType !== 'ALL') {
                    filters.set('side', vm.filters.tradeType);
                }
                if (vm.filters.tradePair.baseAsset !== 'База') {
                    filters.set('base_asset', vm.filters.tradePair.baseAsset);
                }
                if (vm.filters.tradePair.quoteAsset !== 'Котировка') {
                    filters.set('quote_asset', vm.filters.tradePair.quoteAsset);
                }
                if (vm.filters.date.fromDate) {
                    filters.set('created_at_after', vm.filters.date.fromDate);
                }
                if (vm.filters.date.toDate) {
                    filters.set('created_at_before', vm.filters.date.toDate);
                }
                const filtersSearch = filters.size === 0 ? '' : '?' + filters.toString();
                const response = yield vm.services.mainService.tradeHistorySpot(filtersSearch);
                if (response.success) {
                    const result = response.data.items.map((item) => ({
                        side: item.side,
                        name: item.baseAsset + '/' + item.quoteAsset,
                        date: moment(item.createdAt).format('DD.MM.YYYY HH:mm'),
                        marketPrice: item.payload.fills[0].price,
                        volume: item.payload.executedQty,
                        price: item.payload.cummulativeQuoteQty,
                        commission: {
                            value: item.payload.fills[0].commission,
                            asset: item.payload.fills[0].commissionAsset
                        }
                    }));
                    vm.itemsList = result;
                    vm.baseAssetList = response.data.baseAsset.map((item) => ({
                        key: item,
                        value: item
                    }));
                    vm.baseAssetList.unshift({ key: 'ANY_BASE', value: 'Любая' });
                    vm.quoteAssetList = response.data.quoteAsset.map((item) => ({
                        key: item,
                        value: item
                    }));
                    vm.quoteAssetList.unshift({ key: 'ANY_QUOTE', value: 'Любая' });
                }
                else {
                    vm.loadError = true;
                }
                vm.isRetry = false;
            });
        }
    },
    created() {
        this.init();
    }
});
